import React from "react";
import { useAppSelector } from "../../../../store";
import { formatCurrency } from "../../../../utils/formatting";

export const HullArmorSummary: React.FC = () => {
  const {
    totalCost,
    baseHullCost,
    modifiedHullCost,
    optionsCost,
    armorCost,
    hullPoints,
    totalConsumedVolume,
    additionalHullVolume,
    stealthVolume,
    armorVolume,
    solarCoatingPower,
  } = useAppSelector((state) => state.shipBuilder.hullAndArmorStats) || {};

  const shipSize = useAppSelector((state) => state.shipBuilder.shipSize);

  return (
    <div className="bg-gray-800 text-white p-4 shadow-lg">
      <div className="container mx-auto grid grid-cols-[1fr_auto_auto] grid-rows-2 gap-x-12 items-center">
        {/* Row 1: Cost Breakdown */}
        <div className="flex items-center gap-6 text-sm">
          <div>
            <span className="text-gray-400 block">Base Hull</span>
            <span className="font-semibold">
              {formatCurrency(baseHullCost || 0)}
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Adjusted Hull</span>
            <span className="font-semibold">
              {formatCurrency(modifiedHullCost || 0)}
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Options</span>
            <span className="font-semibold">
              {formatCurrency(optionsCost || 0)}
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Armor</span>
            <span className="font-semibold">
              {formatCurrency(armorCost || 0)}
            </span>
          </div>
          {/* Solar Coating Power Output */}
          {typeof solarCoatingPower === "number" && solarCoatingPower > 0 && (
            <>
              <div className="text-gray-400">|</div>
              <div>
                <span className="text-gray-400 block">Solar Coating Power</span>
                <span className="font-semibold">
                  {solarCoatingPower.toFixed(2)} Power
                </span>
              </div>
            </>
          )}
        </div>
        <div className="text-right">
          <span className="text-gray-400 block text-sm">
            Total Hull & Armor Cost
          </span>
          <span className="text-xl font-bold text-green-400">
            {formatCurrency(totalCost || 0)}
          </span>
        </div>

        {/* Hull Points - Spanning both rows */}
        <div className="row-span-2 flex flex-col items-center justify-center border-l border-r border-gray-700 px-8">
          <span className="text-gray-400 block text-sm">Hull Points</span>
          <span className="text-3xl font-bold text-yellow-400">
            {(hullPoints || 0).toFixed(0)}
          </span>
        </div>

        {/* Row 2: Volume Breakdown */}
        <div className="flex items-center gap-6 text-sm border-t border-gray-700 pt-2 mt-2 col-span-1">
          <div>
            <span className="text-gray-400 block">Additional Hull</span>
            <span className="font-semibold">
              {(additionalHullVolume || 0).toFixed(1)} tons
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Stealth</span>
            <span className="font-semibold">
              {(stealthVolume || 0).toFixed(1)} tons
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Armor</span>
            <span className="font-semibold">
              {(armorVolume || 0).toFixed(1)} tons
            </span>
          </div>
        </div>
        <div className="text-right border-t border-gray-700 pt-2 mt-2">
          <span className="text-gray-400 block text-sm">
            Total Consumed Volume
          </span>
          <span className="text-xl font-bold text-blue-400">
            {(totalConsumedVolume || 0).toFixed(1)} tons
          </span>
        </div>
      </div>
    </div>
  );
};
